module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0135.jpg?v=7d8abd13";